<template>
    <div>        
        <div class="news_item d-flex align-items-md-center align-items-start flex-md-row flex-column" @click="slideDown" :class="{active: isActive}">
            <div class="news_item__date d-flex align-items-center me-3">
                <span class="news_item__day"><slot name="day"></slot></span>
                <div class="d-flex flex-column ms-2">
                    <span class="news_item__year"><slot name="year"></slot></span>
                    <span class="news_item__month"><slot name="month"></slot></span>
                </div>
            </div>
            <div class="news_item__title my-md-0 my-2">
                <p class="mb-0"><slot name="title"></slot></p>
            </div>
            <div class="news_item__btn ms-auto my-md-0 my-2" :class="{active: isActive}">
                <i v-if="isActive" class="bi bi-dash-lg"></i>
                <i v-else class="bi bi-plus-lg"></i>
            </div>
        </div>
        <transition name="slide">
            <div class="news_content" v-show="isActive">
                <slot name="editor"></slot>
            </div> 
        </transition>
    </div>
</template>

<script>
export default {
    data(){
        return{
            isActive: false
        }
    },
    methods: {
        slideDown(){
            this.isActive = !this.isActive;
        }
    },
}
</script>

<style lang="scss">
    .slide-enter-active,
    .slide-leave-active {
    transition: max-height 0.2s ease-in-out;
    }

    .slide-enter-to,
    .slide-leave {
    overflow: hidden;
    max-height: 800px;
    }

    .slide-enter,
    .slide-leave-to {
    overflow: hidden;
    max-height: 0;
    }
</style>